import React from 'react';
import { Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import './TooltipStyled.scss';
const useStyles = makeStyles(() => ({
    customTooltip: {
        // backgroundColor: 'white',
        // boxShadow: '2px 2px 4px 0 rgba(56, 58, 57, 0.08)',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        // width: '600px',
        // minWidth: '600px',
        padding: '0',
        margin: '0',
    },
    customArrow: {
        color: 'rgba(220, 0, 78, 0.8)',
    },
}));
const TooltipStyled = ({ title, content, placement = 'right' }) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { classes: {
                tooltip: classes.customTooltip,
                arrow: classes.customArrow,
            }, title: React.createElement("div", { className: "tooltip-smart" }, title), placement: placement }, content)));
};
export default TooltipStyled;
